import classNames from 'classnames'
import { useMemo } from 'react'
import SpinnerLoader from '@/components/Common/header/spinner-loader'

function BaseButton({
  shadows = true,
  paddingClassNames,
  hover = true,
  animateHover = true,
  onClick = () => {},
  text = '',
  marginClassNames = 'my-2',
  primary = true,
  extraClassNames = '',
  disabled = false,
  backgroundColorPrimary,
  backgroundColorSecondary,
  borderColorPrimary,
  textColorPrimary,
  textColorSecondary,
  disabledSpinner = false,
}) {
  const buttonClasses = useMemo(
    () =>
      classNames(
        paddingClassNames,
        marginClassNames,
        extraClassNames,
        {
          [`hover:${textColorPrimary} hover:${backgroundColorSecondary} hover:${borderColorPrimary} ${backgroundColorPrimary} ${textColorSecondary} border-1 rounded-full border-transparent`]:
            hover && primary,
        },
        {
          [`hover:${backgroundColorPrimary} hover:${textColorSecondary} hover:rounded-full hover:border-transparent ${textColorPrimary} ${backgroundColorSecondary} border-1 rounded-full ${borderColorPrimary}`]:
            hover && !primary,
        },
        {
          [`${backgroundColorPrimary} ${textColorSecondary} border-1 rounded-full border-transparent`]:
            primary && !hover,
        },
        {
          [`${textColorPrimary} ${backgroundColorSecondary} border-1 rounded-full ${borderColorPrimary}`]:
            !primary && !hover,
        },
        { 'transition-all duration-100': animateHover },
        { 'shadow-one': shadows },
        { 'opacity-50': disabled },
      ),
    [
      paddingClassNames,
      marginClassNames,
      extraClassNames,
      hover,
      primary,
      animateHover,
      shadows,
      disabled,
      backgroundColorPrimary,
      backgroundColorSecondary,
      borderColorPrimary,
      textColorPrimary,
      textColorSecondary,
    ],
  )

  return (
    <button className={buttonClasses} onClick={onClick} disabled={disabled}>
      {disabledSpinner && disabled ? <SpinnerLoader /> : text}
    </button>
  )
}

export default function PrettyBlueButton(props) {
  return (
    <BaseButton
      paddingClassNames="py-4 px-12"
      backgroundColorPrimary="bg-ind-blue"
      backgroundColorSecondary="bg-grey-tertiary"
      borderColorPrimary="border-ind-blue"
      textColorPrimary="text-ind-blue"
      textColorSecondary="text-ind-white"
      {...props}
    />
  )
}

export function PrettyGreenButton(props) {
  return (
    <BaseButton
      paddingClassNames="py-2.5 px-12"
      backgroundColorPrimary="bg-green"
      backgroundColorSecondary="bg-green"
      borderColorPrimary="border-green"
      textColorPrimary="text-spl-white"
      textColorSecondary="!text-spl-white"
      {...props}
    />
  )
}
